/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable global-require */
/* eslint-disable @typescript-eslint/no-var-requires */

/// <reference path="../../types/redux-thunk-fsa/index.d.ts" />
import { createStore, applyMiddleware, compose } from 'redux';

import promiseMiddleware from 'redux-promise-middleware';
import thunkMiddleware from 'redux-thunk-fsa';

import reducers from 'models/reducers';
import { createEpicMiddleware } from 'redux-observable';
import rootEpic from 'models/epics';

const epicMiddleware = createEpicMiddleware();

const middlewares = [thunkMiddleware, promiseMiddleware, epicMiddleware];
let composeEnhancers = compose;

if (process.env.NODE_ENV !== 'production') {
	const { createLogger } = require('redux-logger');
	middlewares.push(
		createLogger({
			collapsed: (_getState: any, _action: any, logEntry: { error: any }) => !logEntry.error, // 只 collapse 錯誤的 Redux action。
		}),
	);
	composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
}

export default function configureStore(preState: {}) {
	const store = createStore(reducers, preState, composeEnhancers(applyMiddleware(...middlewares)));
	epicMiddleware.run(rootEpic);

	if (module.hot) {
		module.hot.accept('../models/reducers', () => {
			const nextReducers = require('../models/reducers').default;
			store.replaceReducer(nextReducers);
		});
	}

	return store;
}
